<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :total-items="totalItems"
    :label="label || 'Пакети сплати'"
    :items.sync="items"
    placeholder="Введіть найменування або артикул пакету сплати"
    component-name="PaymentPackage"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as packagesApi from "../../../backend/packagesApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Пакети сплати",
    },
    value: {
      type: Object,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await packagesApi.selectPackage(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
